export const icons = {
  player1: ["X", "☻", "♪", "♣", "◐", "🙂", "🥵", "🤘", "🦊", "🍕"],
  player2: ["O", "☺", "♬", "♠", "◑", "🙃", "🥶", "👊", "🐨", "🌮"]
};
